import React, { useState } from "react";

const AddTripMember = ({ tripId, onMemberAdded }) => {
  const [email, setEmail] = useState("");

  const addTripMember = async () => {
    const token = localStorage.getItem("token");

    const response = await fetch(`${process.env.REACT_APP_API_URL}/tripmembers/add_trip_member_by_email/?trip_id=` + tripId + `&email=` + encodeURIComponent(email), {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

	if (response.ok) {
	  const result = await response.json();
	  console.log(result); // <== 加這行看一下到底 response 是什麼
	  
	  if (result.status === "invited") {
		alert("Invitation email sent. Waiting for them to register.");
	  } else {
		alert("Member added successfully");
		if (onMemberAdded) onMemberAdded();
	  }
	  setEmail("");
	} else {
	  const error = await response.json();
	  alert("Failed to add：" + error.detail);
	}	
  };

  return (
	<div className="p-4 border border-accent rounded shadow-md bg-background mb-4 responsive-container">
	  <h2 className="heading text-primary mb-2">Add Trip Member</h2>
	  <input
		type="email"
		value={email}
		onChange={(e) => setEmail(e.target.value)}
		placeholder="Member Email"
		className="form-input mb-2"
	  />
	  <button
		onClick={addTripMember}
		className="btn-full bg-primary text-white p-2 rounded hover:bg-orange-600 transition"
	  >
		Add Trip Member
	  </button>
	</div>
  );
};

export default AddTripMember;
